import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			Ĉiam, kiam la spektaklo proksimiĝas al fino, la Kurteno ekscitiĝas: ja baldaŭ lia elveno. Kiel renkontos lin la publiko? Ĉu li pretas? Li atente pririgardas sin, formetas iun apenaŭ videblan polveron, kaj – aperas sur la scenejo.
		</p>
		
		<p class="mb-3">
			La publiko tuj vigliĝas. La spektantoj ekstaras de siaj lokoj, aplaŭdas, krias «bravo!». La Kurteno, longjara kaj elprovita servanto de la scenejo, eĉ hontas, ke oni lin renkontas tiel jubile. Tial, iom svingiĝinte por la publiko, la Kurteno hastas reen, en la kulisojn.
		</p>
		
		<p class="mb-3">
			Sed la aplaŭdoj fortiĝas.
		</p>
		
		<p class="mb-3">
			- Oni vokas, - pensas la Kurteno. – Nu, kion fari, endas eliri.
		</p>
		
		<p class="mb-3">
			Tiel li eliradas kelkfoje, kaj poste, post ioma hezito, definitive restas sur la scenejo. Li deziras danki la publikon pro ĝia atentemo.
		</p>
		
		<p class="mb-3">
			Sed nun – ho nigra sendankeco! – la publiko komencas disiri.
		</p>
		`
	)
}

const itemName = {
	esp: 'Kurteno'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;